import React, { Component, Fragment } from 'react';
import { Upload, Modal } from 'antd';

class AvatarCustom extends Component {
    state = {
        previewVisible: false,
        previewImage: '',
        fileList: []
    };

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true
        });
    }

    handleChange = ({fileList}) => {
        this.props.onChange(fileList);
        this.setState({fileList})
    }

    beforeUpload = (file) => {
        return false
    }

    renderName = () =>{
        const { name } = this.props
        const tokens = name.split(' ');
        let token = tokens
        if (tokens.length > 1) {
            token = tokens[0]
                .charAt(0)
                .toUpperCase() + tokens[1]
                .charAt(0)
                .toUpperCase();
        } else if (tokens.length === 1) {
            if (tokens[0].length > 1) {
                token = tokens[0]
                    .substring(0, 2)
                    .toUpperCase();
            }
        }
        return token
    }

    render() {
        const { name, img } = this.props;
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadButton = (
            <Fragment>
                <div className={`default-value ${name || img ? '' : 'hidden-wrap'}`}>
                    <div className={`default-image ${img ? '' : 'hidden-wrap'}`}>
                        <img src={img} alt="" />
                    </div>
                    <div className="text-name">{this.renderName()}</div>
                    <div className="avatar-upload-btn">
                        <div className="ant-upload-text">Change</div>
                    </div>
                </div>
                <div className={`on-value ${name || img ? 'hidden-wrap' : ''}`}>
                    <div className="avatar-upload-btn">
                        <div className="ant-upload-text">Change</div>
                    </div>
                </div>
            </Fragment>
        );

        return (

            <Fragment>
                <Upload
                    className="avatar-upload"
                    listType="picture-card"
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    beforeUpload={this.beforeUpload}
                    fileList={fileList} >
                    {fileList.length >= 1
                        ? null
                        : uploadButton}
                </Upload>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img
                        alt="example"
                        style={{
                            width: '100%'
                        }}
                        src={previewImage} />
                </Modal>
            </Fragment>
        );
    }
}

export default AvatarCustom;
